export default __webpack_public_path__ + "static/media/icon_lock_cirle.80144ca6.svg";